export default __webpack_public_path__ + "static/circuit2Mobile-fd58ae19a2fefc2b5fbe7ff5aebce4b6.svg";